export { ModalWindow } from './ModalWindow'



// WEBPACK FOOTER //
// ./src/views/components/ModalWindow/index.tsx